import React, { useEffect, useState } from "react";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";

const IoArrowBack = require("react-icons/io5").IoArrowBack;
const FaPlus = require("react-icons/fa").FaPlus;
const IoClose = require("react-icons/io5").IoClose;

const TambahProduk = () => {
  const navigate = useNavigate();

  const [name, setName] = useState("");
  const [price, setPrice] = useState("");
  const [stock, setStock] = useState("");
  const [categoryId, setCategoryId] = useState("");
  const [description, setDescription] = useState("");
  const [status, setStatus] = useState("aktif");
  const [discount, setDiscount] = useState("");

  const [sizes, setSizes] = useState<string[]>([]);
  const [colors, setColors] = useState<string[]>([]);
  const [images, setImages] = useState<File[]>([]);

  const [sizeInput, setSizeInput] = useState("");
  const [colorInput, setColorInput] = useState("");

  const [categories, setCategories] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);

  const token = document.cookie
    .split("; ")
    .find((row) => row.startsWith("token="))
    ?.split("=")[1];

  const API = process.env.REACT_APP_API_BASE_URL;

  useEffect(() => {
    fetchCategories();
  }, []);

  const fetchCategories = async () => {
    const res = await axios.get(`${API}/api/categories`);
    setCategories(res.data);
  };

  const handleAddSize = () => {
    if (sizeInput) {
      setSizes([...sizes, sizeInput]);
      setSizeInput("");
    }
  };

  const handleAddColor = () => {
    if (colorInput) {
      setColors([...colors, colorInput]);
      setColorInput("");
    }
  };

  const handleImageChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (!e.target.files) return;

    const files = Array.from(e.target.files);
    setImages((prev) => [...prev, ...files]);
  };

  const removeSize = (index: number) => {
    setSizes(sizes.filter((_, i) => i !== index));
  };

  const removeColor = (index: number) => {
    setColors(colors.filter((_, i) => i !== index));
  };

  const removeImage = (index: number) => {
    setImages(images.filter((_, i) => i !== index));
  };

  const handleSubmit = async (e: any) => {
    e.preventDefault();

    const formData = new FormData();

    formData.append("name", name);
    formData.append("price", price);
    formData.append("stock", stock);
    formData.append("category_id", categoryId);
    formData.append("description", description);
    formData.append("status", status);
    formData.append("discount", discount);

    sizes.forEach((size) => formData.append("sizes[]", size));
    colors.forEach((color) => formData.append("colors[]", color));
    images.forEach((img) => formData.append("images[]", img));

    try {
      setLoading(true);

      await axios.post(`${API}/api/produk`, formData, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      });

      await Swal.fire({
        icon: "success",
        title: "Berhasil!",
        text: "Produk berhasil ditambahkan",
        confirmButtonColor: "#eab308",
        confirmButtonText: "OK",
      });

      navigate("/dashboard/produk");
    } catch (err) {
      console.error(err);

      Swal.fire({
        icon: "error",
        title: "Gagal!",
        text: "Produk gagal ditambahkan",
        confirmButtonColor: "#ef4444",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-4xl mx-auto mt-8 bg-white p-6 rounded-xl shadow">
      <Link to="/dashboard/produk" className="flex items-center gap-2 mb-6">
        <IoArrowBack />
        <h2 className="text-xl font-bold">Tambah Produk</h2>
      </Link>

      <form onSubmit={handleSubmit} className="space-y-5">
        {/* Nama */}
        <div>
          <label className="font-semibold">Nama Produk</label>
          <input className="w-full border rounded p-2" value={name} onChange={(e) => setName(e.target.value)} />
        </div>

        {/* Price + Stock */}
        <div className="grid grid-cols-2 gap-4">
          <div>
            <label className="font-semibold">Harga</label>
            <input type="number" className="w-full border rounded p-2" value={price} onChange={(e) => setPrice(e.target.value)} />
          </div>

          <div>
            <label className="font-semibold">Stock</label>
            <input type="number" className="w-full border rounded p-2" value={stock} onChange={(e) => setStock(e.target.value)} />
          </div>
        </div>

        {/* Category */}
        <div>
          <label className="font-semibold">Kategori</label>
          <select className="w-full border rounded p-2" value={categoryId} onChange={(e) => setCategoryId(e.target.value)}>
            <option value="">Pilih Kategori</option>

            {categories.map((cat) => (
              <option key={cat.id} value={cat.id}>
                {cat.name}
              </option>
            ))}
          </select>
        </div>

        {/* Description */}
        <div>
          <label className="font-semibold">Deskripsi</label>
          <textarea className="w-full border rounded p-2" rows={4} value={description} onChange={(e) => setDescription(e.target.value)} />
        </div>

        {/* Discount */}
        <div>
          <label className="font-semibold">Diskon (%)</label>
          <input type="number" className="w-full border rounded p-2" value={discount} onChange={(e) => setDiscount(e.target.value)} />
        </div>

        {/* Sizes */}
        <div>
          <label className="font-semibold">Ukuran</label>

          <div className="flex gap-2 mb-2">
            <input className="border rounded p-2" value={sizeInput} onChange={(e) => setSizeInput(e.target.value)} />

            <button type="button" onClick={handleAddSize} className="bg-black text-white px-3 rounded">
              <FaPlus />
            </button>
          </div>

          <div className="flex gap-2 flex-wrap">
            {sizes.map((size, i) => (
              <div key={i} className="relative bg-gray-200 px-3 py-1 rounded">
                <button type="button" onClick={() => removeSize(i)} className="absolute -top-2 -right-2 bg-red-500 text-white rounded-full w-5 h-5 flex items-center justify-center text-xs">
                  <IoClose />
                </button>

                {size}
              </div>
            ))}
          </div>
        </div>

        {/* Colors */}
        <div>
          <label className="font-semibold">Warna</label>

          <div className="flex gap-2 mb-2">
            <input className="border rounded p-2" value={colorInput} onChange={(e) => setColorInput(e.target.value)} />

            <button type="button" onClick={handleAddColor} className="bg-black text-white px-3 rounded">
              <FaPlus />
            </button>
          </div>

          <div className="flex gap-2 flex-wrap">
            {colors.map((color, i) => (
              <div key={i} className="relative bg-gray-200 px-3 py-1 rounded">
                <button type="button" onClick={() => removeColor(i)} className="absolute -top-2 -right-2 bg-red-500 text-white rounded-full w-5 h-5 flex items-center justify-center text-xs">
                  <IoClose />
                </button>

                {color}
              </div>
            ))}
          </div>
        </div>

        {/* Images */}
        <div>
          <label className="font-semibold">Upload Gambar</label>

          <input type="file" multiple onChange={handleImageChange} className="w-full border p-2" />

          <div className="flex gap-3 mt-3 flex-wrap">
            {images.map((img, i) => (
              <div key={i} className="relative">
                <button type="button" onClick={() => removeImage(i)} className="absolute -top-2 -right-2 bg-red-500 text-white rounded-full w-6 h-6 flex items-center justify-center">
                  <IoClose />
                </button>

                <img alt="" src={URL.createObjectURL(img)} className="w-24 h-24 object-cover rounded" />
              </div>
            ))}
          </div>
        </div>

        <button disabled={loading} className="w-full bg-yellow-500 text-black font-semibold py-3 rounded-lg hover:bg-yellow-600">
          {loading ? "Menyimpan..." : "Simpan Produk"}
        </button>
      </form>
    </div>
  );
};

export default TambahProduk;
